import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../services/localStorage/local-storage.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);
  const token = localStorageService.getAuthToken();
  console.log('AUTH GUARD TOKEN:', token);
  console.log('AUTH GUARD URL:', state.url);

  if (token != null) {
    return true;
  } else {
    router.navigateByUrl('auth/login');
    return false;
  }
};
